(function () {
  async function addItemToCart(e) {
    e.target.disabled = true;
    const variantId = e.target.dataset.variantId;

    const payload = {
      items: [
        {
          id: variantId,
          quantity: 1,
        },
      ],
    };

    if (e.target.dataset.sellingPlanId) {
      payload.items[0]['selling_plan'] = e.target.dataset.sellingPlanId;
    }

    if (e.target.dataset.mv_30) {
      payload.items[0]['properties'] = payload.items[0]['properties'] || {};
      payload.items[0]['properties']['_mv_lp_30'] = 'true';
    }

    if (e.target.dataset.mv_patients) {
      payload.items[0]['properties'] = payload.items[0]['properties'] || {};
      payload.items[0]['properties']['_mv_lp_patients'] = 'true';
    }

    if (
      e.target.dataset['4weekPlanId'] !== null ||
      e.target.dataset['4weekPlanId'] !== ''
    ) {
      payload.items[0]['selling_plan'] = e.target.dataset['4weekPlanId'];
    }

    if (
      (variantId == 47245051461877 || variantId == 47245045793013) &&
      e.target.dataset.freeFunnel
    ) {
      const funnelPayload = {
        id: 47238772916469,
        quantity: 1,
        properties: {
          _free_funnel: 'true',
        },
      };
      payload.items.push(funnelPayload);
    }

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(payload),
      });
      await res.json();
      Shopify.openCartDrawer();
      e.target.disabled = false;
    } catch (err) {
      console.log(err);
      e.target.disabled = false;
    }
  }

  window.addEventListener('load', function () {
    const addToCartButtons = document.querySelectorAll('.collection__atc');

    addToCartButtons.forEach(function (btn) {
      btn.addEventListener('click', addItemToCart);
    });

    const ratings = document.querySelectorAll(
      '[data-oke-reviews-product-listing-rating]',
    );

    if (!ratings.length) {
      return;
    }

    ratings.forEach(function (rating) {
      if (rating.children.length) {
        for (let child of rating.children) {
          if (child.textContent.trim() == '') {
            rating.style.display = 'none';
          }
        }
      }
    });
  });

  // Add UTM params to product links in collections with '-paid' in the URL
  window.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('section.js-collection-paid')) {
      const collectionGrid = document.querySelector(
        'section.js-collection-paid .collection__products',
      );
      const productCardLinks = collectionGrid?.querySelectorAll(
        '.collection__products__item a',
      );

      productCardLinks.forEach((link) => {
        const url = new URL(link.href);
        url.searchParams.set('status', 'paid');
        link.href = url.toString();
      });
    }

    if (document.querySelector('section.js-collection-patients')) {
      const collectionGrid = document.querySelector(
        'section.js-collection-patients .collection__products',
      );
      const productCardLinks = collectionGrid?.querySelectorAll(
        '.collection__products__item a',
      );

      productCardLinks.forEach((link) => {
        const url = new URL(link.href);
        url.searchParams.set('status', 'patients');
        link.href = url.toString();
      });
    }

    const otpSpParam = new URLSearchParams(window.location.search).get('sp');
    if (otpSpParam === 'otp' || otpSpParam === 'otp2') {
      const productCardLinks = document
        .querySelector('.collection__products')
        ?.querySelectorAll('.collection__products__item a');

      productCardLinks?.forEach((link) => {
        const url = new URL(link.href);
        url.searchParams.set('sp', otpSpParam);
        link.href = url.toString();
      });
    }
  });
})();